import { Box, Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Dialog } from '@opendoor/atoms/dialog';
import { Text } from '@opendoor/atoms/text';
import { IconCalendarCheck, IconFileCheck, IconLogin2, IconX } from '@tabler/icons-react';

const TITLE = 'How it works';

const STEPS = [
  {
    icon: IconLogin2,
    title: 'Sign in',
    subtitle: 'Sign into Opendoor to make an offer',
  },
  {
    icon: IconCalendarCheck,
    title: 'Confirm your details',
    subtitle: 'Select your financing option and closing date',
  },
  {
    icon: IconFileCheck,
    title: 'Review and submit your offer',
    subtitle: 'No paperwork needed, takes less than 5 min.',
  },
];

export const BuyDirectContextModal = ({
  isOpen,
  onClose,
  continueHref,
}: {
  isOpen: boolean;
  onClose: () => void;
  continueHref: string;
}) => (
  <Dialog.Root
    role="dialog"
    open={isOpen}
    onOpenChange={(open) => {
      if (!open) {
        onClose();
      }
    }}
  >
    <Dialog>
      <Dialog.Close
        render={(props) => (
          <Button
            {...props}
            variant="secondary"
            size="sm"
            aria-label="Close"
            analyticsName="cosmos-marketplace-buy-direct-context-close"
            className="absolute top-6 right-6 h-11 w-11 rounded-full border-0 p-0 sm:hidden"
          >
            <IconX size={24} />
          </Button>
        )}
      />
      {/* Sized to match the PDP address in PropertySummary. */}
      <Dialog.Title className="pb-1 pr-12 text-subheader-sm text-od-content-primary sm:pb-1 sm:pr-0 md:text-subheader-lg">
        {TITLE}
      </Dialog.Title>
      <Col className="w-full pt-6 md:w-110">
        <Col className="w-full">
          {STEPS.map(({ icon: Icon, title, subtitle }, index) => {
            const isLast = index === STEPS.length - 1;
            return (
              <Row key={title} className="w-full items-stretch">
                <Col className="items-center pr-4">
                  <Box className="size-10 shrink-0 items-center justify-center rounded-full border border-od-border-primary bg-od-bg-secondary">
                    <Icon size={20} className="text-od-content-secondary" />
                  </Box>
                  {!isLast && <Box className="w-px flex-1 bg-od-border-primary" />}
                </Col>
                <Col className={`items-start ${isLast ? '' : 'pb-6'}`}>
                  <Text className="text-body-md font-medium text-od-content-primary">{title}</Text>
                  <Text className="text-body-sm text-od-content-primary">{subtitle}</Text>
                </Col>
              </Row>
            );
          })}
        </Col>
        <Box className="w-full pt-12">
          <Button
            analyticsName="cosmos-marketplace-buy-direct-context-continue"
            aria-label="Sign in"
            href={continueHref}
            variant="primary"
            size="lg"
            className="w-full"
          >
            Sign in
          </Button>
        </Box>
      </Col>
    </Dialog>
  </Dialog.Root>
);
